import {
  ProductPrice,
  ProductTile as TProductTile,
} from "~/entities/product/types";

type Props = Omit<TProductTile, "id"> &
  Partial<Pick<ProductPrice, "price" | "callout">>;

const ProductTile: React.FC<Props> = ({
  name,
  path,
  millLogo,
  mainImage,
  variantImages,
  price,
  callout,
}) => {
  const image =
    mainImage ||
    variantImages?.front ||
    variantImages?.side ||
    variantImages?.back;

  return (
    <a
      href={`/${path}`}
      aria-label={name + " link"}
      className="related-product relative flex flex-col gap-y-2 border border-white100 p-2.5 hover:border-blue900"
    >
      <div
        className={`related-product__callout ${callout ? "block" : "hidden"} absolute right-0 top-0 z-10 mr-[-5px] mt-[-5px] ${callout === "New Arrival" ? "bg-magenta" : "bg-red100"} px-4 py-[5px] text-[13px] leading-[1] text-white`}
      >
        {callout}
      </div>
      <div className="relative -left-[10px] flex h-[51vw] w-[calc(100%+20px)] items-center justify-center overflow-hidden xsm:h-[35vw] lg:h-[200px]">
        <img
          src={image ?? ""}
          aria-label={name + " image"}
          className="related-product__image absolute -left-full -right-full bottom-auto top-0 m-auto block h-auto w-full"
        />
      </div>
      <div className="flex w-full justify-between">
        <div className="flex flex-col">
          <div className="flex flex-col gap-1">
            <span className="text-[0.5rem] font-bold uppercase leading-none text-gray100 xsm:text-[0.625rem]">
              STARTING AT:
            </span>
            <span
              className={`related-product__price text-[1rem] font-bold leading-none text-green transition-opacity xsm:text-[1.25rem] ${price ? "opacity-100" : "opacity-0"}`}
            >
              {price ?? ""}
            </span>
          </div>
        </div>
        {millLogo ? (
          <div className="max-w-[3.125rem]">
            <img
              src={millLogo}
              aria-label={name + " logo"}
              className="related-product__logo h-auto w-full"
            />
          </div>
        ) : null}
      </div>
      <h3 className="related-product__name mt-1 text-[0.875rem] font-medium leading-[1.25] text-[#00529B]">
        {name}
      </h3>
    </a>
  );
};

export default ProductTile;
